<template>
  <div class="qr-generator-view">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card class="qr-card">
            <v-card-title class="qr-card-title">
              <v-icon color="success" size="24" class="mr-2">mdi-qrcode</v-icon>
              <span>QR-Code Generator</span>
            </v-card-title>

            <v-divider class="card-divider"></v-divider>

            <v-card-text class="qr-card-content">
              <p class="description mb-6">
                Erstellen Sie einen QR-Code aus einem beliebigen Text oder Passwort.
                Der QR-Code kann gespeichert, gedruckt oder abfotografiert werden.
              </p>

              <QRCodeGenerator
                label="Text oder Passwort für QR-Code"
                :secure="true"
              />
            </v-card-text>

            <v-divider class="card-divider"></v-divider>

            <v-card-actions class="qr-card-actions">
              <v-spacer></v-spacer>
              <v-btn
                variant="text"
                color="grey"
                @click="$router.go(-1)"
                class="return-btn"
              >
                <v-icon start>mdi-arrow-left</v-icon>
                Zurück
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import QRCodeGenerator from '@/components/QRCodeGenerator.vue';
</script>

<style scoped>
.qr-generator-view {
  min-height: calc(100vh - 200px);
  padding: 24px 0;
}

.qr-card {
  background: rgba(30, 30, 40, 0.85) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.qr-card-title {
  background: linear-gradient(to right, rgba(76, 175, 80, 0.1), transparent);
  padding: 16px 20px;
  font-weight: 500;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
}

.card-divider {
  border-color: rgba(255, 255, 255, 0.08);
}

.qr-card-content {
  padding: 24px;
}

.description {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.5;
}

.qr-card-actions {
  padding: 8px 16px 16px;
}

.return-btn {
  transition: transform 0.2s ease;
}

.return-btn:hover {
  transform: translateX(-3px);
}
</style>
